import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "m-bottom-25" }, "Create your new password", -1)
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_base_input, {
      title: "New password",
      type: "password",
      bind: { autocomplete: 'new-password' },
      errors: _ctx.formErrors.new,
      value: _ctx.password.new,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password.new) = $event))
    }, null, 8, ["errors", "value"]),
    _createVNode(_component_base_input, {
      title: "Confirm new password",
      type: "password",
      bind: { autocomplete: 'new-password' },
      errors: _ctx.formErrors.confirm,
      value: _ctx.password.confirm,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password.confirm) = $event))
    }, null, 8, ["errors", "value"]),
    _createElementVNode("button", {
      class: _normalizeClass(["btn fill t-t-u", { spinner: _ctx.loader }]),
      disabled: _ctx.loader,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
    }, "Submit", 10, _hoisted_2)
  ], 64))
}